export const QUOTATION_PDF_URL = 'v2/order/quotations/pdf'